// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"344":"3a589860912abf67a995","991":"4344d0e5731a64c61453"}[chunkId] + ".css";
};